import type { FlagsValueType } from './FlagsProvider';

export const FLAGS = {
  CLIENT_TOKEN_CHECK: 'CLIENT_TOKEN_CHECK',
  AOI: 'AOI',
  TREE_SPECIES: 'TREE_SPECIES',
  CROP_TYPE_HSI: 'CROP_TYPE_HSI'
} as const;

export type FLAGS_KEYS = keyof typeof FLAGS;

export const FLAGS_LIST: {
  name: FLAGS_KEYS;
  defaultValue: FlagsValueType;
}[] = [
  { name: FLAGS.CLIENT_TOKEN_CHECK, defaultValue: false },
  { name: FLAGS.AOI, defaultValue: false },
  {
    name: FLAGS.TREE_SPECIES,
    defaultValue: false
  },
  { name: FLAGS.CROP_TYPE_HSI, defaultValue: false }
];
